import { AxiosResponse } from 'axios'
import { get, post } from '../../utils/api'
import { InviteFormType } from './types'

export const fetchTeachers = (): Promise<AxiosResponse> =>
  get('/me/profile/relations')

export const sendInviteTeacher = (
  data: InviteFormType
): Promise<AxiosResponse> => post('/me/profile/teachers', data)

export const fetchReferralLink = (
  type: string,
  redirect_url: string,
  is_reversive: string,
  connection_type: string
): Promise<AxiosResponse> =>
  post('/me/profile/referral-link', {
    type,
    redirect_url,
    is_reversive,
    connection_type,
  })

export const connectByShortId = (
  code: string,
  short_id: string
): Promise<AxiosResponse> =>
  post('/me/profile/connect-by-short-id', { code, short_id })
